import React, { useEffect } from "react"
import styles from "./index.module.scss"
import { Order } from "../../../../molecules/OrderTable"
import RcmpLoading from "../../../../atoms/Loading"
import intl from "react-intl-universal"
import Select from "../../../../atoms/Select"
import PlusIcons from "../../../../../assets/icons/PlusIcons"
import { useNavigate } from "react-router-dom"
import { toast } from "@stardust-ds/react"
import { SwitchSigma } from "../SwtchSigma"

function TableComponent({
  load,
  thead,
  tbodyArray,
  cursorNormal = false,
  cTextNoData = intl.get("no_data"),
  bNotShowIfEmpty = false,
  fnOrder,
  loadingInnerTable,
  cActiveArrowOrder,
  handleCaptureId,
  biologicalVariable,
  updateAnalyte,
  setBOpenModalDRM,
}) {
  const [activeColumnIndex, setActiveColumnIndex] = React.useState(null)
  const navigate = useNavigate()
  // const isOnlyAccessModuleCiq = fnisOnlyPermition("access-ciq")

  const fnLasPosition = (idx, th, conditionOne, conditionTwo) => {
    return idx === th.length - 1 && idx === 5 ? conditionOne : conditionTwo
  }

  useEffect(() => {
    if (cActiveArrowOrder === "control_vstatus") {
      const columStatus = document.getElementById("Status")
      if (columStatus) {
        columStatus.click()
      }
    }
  }, [tbodyArray?.length > 0])

  if (!tbodyArray || tbodyArray.length === 0 || !biologicalVariable?.length) {
    if (load || !biologicalVariable?.length) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
            width: "100%",
          }}
        >
          <RcmpLoading bShow={true} size={50} />
        </div>
      )
    }
    if (bNotShowIfEmpty) {
      return <></>
    }
    return (
      <>
        <table className={styles.table}>
          <thead className={styles.head}>
            <tr>
              {thead.map((item, index, array) => (
                <th
                  className="th"
                  key={index}
                  style={{
                    textAlign: item === "Ações" ? "center" : "left",
                  }}
                >
                  <span className={styles.noText}>{item}</span>
                </th>
              ))}
            </tr>
          </thead>
        </table>
        <p className={styles.textNoData}>{cTextNoData}</p>
      </>
    )
  }

  const columns = Object.keys(tbodyArray[0])

  const fnOrderColumnBy = (ev, index, columns) => {
    if (index === thead.length - 1) return

    document.querySelectorAll(".th").forEach((item) => {
      item.classList.remove(styles.opacity)
    })

    ev.currentTarget?.classList.add(styles.opacity)

    const isActive = index === activeColumnIndex

    setActiveColumnIndex(isActive ? null : index)

    if (columns[index].includes("nid")) {
      return
    }
    if (fnOrder) {
      fnOrder(columns[index], !isActive ? "asc" : "desc")
    }
  }

  const fnAlertSigmaUnavailable = () => {
    toast({
      type: "warning",
      title: intl.get("sigma.unable_to_activate_sigma_title"),
      description:
      intl.get("sigma.unable_to_activate_sigma_description"),
    })
  }

  return (
    <div className={styles.containerTable}>
      <table className={styles.table}>
        <thead className={styles.head}>
          <tr>
            {thead.map((item, index) => (
              <th
                key={index}
                style={{
                  textAlign: "center",
                  cursor: fnLasPosition(index, thead, "default", "pointer"),
                }}
                id={item}
                className={`${
                  item.toLowerCase().includes("name") || item.includes("observation")
                    ? styles.widthLarge
                    : styles.widthNormal
                } th`}
                onClick={(ev) => {
                  fnOrderColumnBy(ev, index, columns)
                }}
              >
                {!columns[index].includes("nid") ? (
                  <span style={{ display: "block", width: "100%", textAlign: "center" }}>
                    {item}
                    {typeof fnOrder === "function" && (
                      <Order
                        columnIndex={index}
                        activeColumnIndex={activeColumnIndex}
                        setActiveColumnIndex={setActiveColumnIndex}
                      />
                    )}
                  </span>
                ) : (
                  item
                )}
              </th>
            ))}
            <th>
              Status
            </th>
          </tr>
        </thead>
        <tbody className={styles.tableBody}>
          {loadingInnerTable ? (
            <></>
          ) : (
            tbodyArray?.map((item, rowIndex) => {
              const defaultValue = biologicalVariable?.find(
                (it) => it.id === item.anlt_biovar_nid,
              )
              return (
                <tr
                  key={rowIndex}
                  style={{
                    cursor: cursorNormal ? "default" : "pointer",
                  }}
                >
                  {columns
                    .filter((item) => !item.includes("id"))
                    .map((column, columnIndex) => {
                      return (
                        <td
                          key={columnIndex}
                          className={`${styles.td} ${
                            column.includes("name") || column.includes("observation")
                              ? styles.widthLarge
                              : styles.widthNormal
                          } ${column.includes("name") ? styles.nameField : ""}`}
                        >
                          {column.includes("error_total") ? (
                            <div className={`${styles.itemFlex}`}>
                              <Select
                                className={styles.select}
                                width="100%"
                                options={biologicalVariable}
                                defaultValue={defaultValue}
                                searchable={true}
                                placeholder={intl.get("select_unit")}
                                onSelect={(biologicalItem) => {
                                  if (defaultValue?.id !== biologicalItem.id) {
                                    updateAnalyte(item.anlt_nid, biologicalItem.id)
                                  }
                                }}
                              />
                            </div>
                          ) : column.includes("drm") ? (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "1rem",
                              }}
                            >
                              {!item.drm ? (
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-evenly",
                                  }}
                                >
                                  <span /> {/* placeholder */}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "end",
                                      gap: "1rem",
                                    }}
                                  >
                                    <p className={styles.drmValue}>-</p>
                                    <PlusIcons
                                      stroke="#3B454F"
                                      cursor="pointer"
                                      onClick={() => {
                                        handleCaptureId(item)
                                        setBOpenModalDRM(true)
                                      }}
                                    />
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <span className={styles.drmValue}>
                                    {item.drm || "-"}
                                  </span>
                                  <PlusIcons
                                    stroke="#3B454F"
                                    cursor="pointer"
                                    onClick={() => {
                                      handleCaptureId(item)
                                      setBOpenModalDRM(true)
                                    }}
                                  />
                                </>
                              )}
                            </div>
                          ) : column.includes("sigma") ? (
                            item.sigma === null ? (
                              <div className={styles.boxSigma}>-</div>
                            ) : (
                              <div className={styles.boxSigma}>
                                {Number(item.sigma).toFixed(2).replace(".", ",")}
                              </div>
                            )
                          ) : column.includes("power_detection") ? (
                            item.power_detection || " - "
                          ) : column.includes("possibility_rejection") ? (
                            item.possibility_rejection || " - "
                          ) : column.includes("rule_decision") ? (
                            item?.rule_decision?.join("/") || " - "
                          ) : column.includes("coef") ? (
                            item.coef_variation === null ? (
                              <a
                                target="_blank"
                                rel="noreferrer"
                                className={styles.notCalculated}
                                onClick={() => {
                                  navigate(
                                    `/ciq/release/${item.eqp_nid}/details/${item.anlt_nid}`,
                                  )
                                }}
                              >
                                {intl.get("sigma.not_calculated")}
                              </a>
                            ) : (
                              item.coef_variation
                            )
                          ) : column.includes("active") ? (
                            <div className={styles.containerActive}>
                              <SwitchSigma
                                className={styles.sigmaActiveSwitch}
                                checked={item.bSigma}
                                onClick={() => {
                                  if (
                                    item.drm !== null &&
                                    item.sigma !== null &&
                                    item.coef_variation !== null
                                  ) {
                                    handleCaptureId({
                                      ...item,
                                      bShowSgmaUpdateStatusModal: true,
                                    })
                                  } else {
                                    fnAlertSigmaUnavailable()
                                  }
                                }}
                              />

                              <span className={styles.labelActive}>
                                {intl.get("ciq.active_up")}
                              </span>
                            </div>
                          ) : (
                            item[column]
                          )}
                        </td>
                      )
                    })}
                </tr>
              )
            })
          )}
        </tbody>
      </table>

      {loadingInnerTable && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1rem",
              borderRadius: "4px",
              width: "100%",
            }}
          >
            <RcmpLoading bShow={true} size={50} />
          </div>
        </>
      )}
    </div>
  )
}

export const TableAnalytesInEquipment = TableComponent
